import React from "react";
import { useSelector } from "react-redux";
import Navbar from "../Common/Navbar";
import SideMenubar from "./SideMenubar";

const DashLayout = ({
  children,
  hideSearchbar,
  hideAvatarList,
  hideStudentView,
}) => {
  const selectedLanguage = useSelector(
    (store) => store.common.auth.selectedLanguage
  );
  const isSidebarOpen = useSelector(
    (state) => state.common.user.sidebar.isOpen
  );

  const isRTL = ["ar", "ur"].includes(selectedLanguage);
  const sidebarWidth = isSidebarOpen ? "15%" : "7%";

  return (
    <div
      className={`flex w-full h-screen overflow-hidden`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <SideMenubar />

      <div
        className="flex flex-col flex-1 overflow-hidden"
        style={{
          marginRight: isRTL ? sidebarWidth : 0,
          marginLeft: !isRTL ? sidebarWidth : 0,
          transition: "margin 500ms ease",
        }}
      >
        <Navbar
          hideSearchbar={hideSearchbar}
          hideAvatarList={hideAvatarList}
          hideStudentView={hideStudentView}
        />

     
          <main className="flex-1 overflow-y-auto overflow-x-hidden smooth-scroll">
            <div className="">{children}</div>
          </main>

      </div>
    </div>
  );
};

export default DashLayout;